import axios from 'axios';
import { useState } from 'react';
import FullPageLoader from '../components/FullPageLoader';

const ClientHome = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [isTranslated, setIsTranslated] = useState(false);

    const translate = (lang) => {
        let ind = 1;
        if(lang == 'en'){
            if(!isTranslated){  //document.getElementsByClassName('goog-te-combo')[0].options[0].value == ''){
                return;
            }
            ind = 0;
        }
        else if(isTranslated){
            return;
        }
        setIsTranslated(ind ? true : false);
       
        document.getElementsByClassName('goog-te-combo')[0].options[ind].selected = true;
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent('change', true, true ); // event type,bubbling,cancelable
        return !document.getElementsByClassName('goog-te-combo')[0].options[ind].dispatchEvent(evt);
        
    };

    const generateToken = async() => {
        // const config = {
        //     method: 'POST',
        //     url: 'https://mock.powercred.io/oAuth/generateAccessToken?apikey=d3g0ziO2UZoOtIF1QtkfHiXIcS8glAu2NuCCIC675zqlaB5g',
        //     headers: { 
        //         'Authorization': 'Basic aWlWMHBpclNacG5LdWR0UVg0TUNyTmdBSGJVVEFuT3dPU1FNNEJPZlZyZndVcXlwOmxVdzRUdFFVSFNrbFhERXRhMkE1d2s1dmFjekpJSWxyZGdJTzRwN25pUEh5bzhHUUFsUGNwS0FJR09OTWlGTng=', 
        //         'Content-Type': 'application/x-www-form-urlencoded'
        //     },
        //     data: JSON.stringify({
        //         'grant_type': 'client_credentials' 
        //     })
        // };
        setIsLoading(true);
        const config = {
            method: 'POST',
            url: 'https://dev.powercred.io/auth/token?apikey=d3g0ziO2UZoOtIF1QtkfHiXIcS8glAu2NuCCIC675zqlaB5g&client_id=d3g0ziO2UZoOtIF1QtkfHiXIcS8glAu2NuCCIC675zqlaB5g&client_secret=lUw4TtQUHSklXDEta2A5wk5vaczJIIlrdgIO4p7niPHyo8GQAlPcpKAIGONMiFNx',
        };
        let response;
        try{
            response = await axios(config);
            console.log(response.data.url);
            window.open('home?'+response.data.url.split('?')[1], '_self');
        }
        catch(e){
            console.log('error ', e);
        }
        setIsLoading(false);
        // response = {
        //     url: 'home?access_token=12134ewdsc&id=1234567890&client_id=d3g0ziO2UZoOtIF1QtkfHiXIcS8glAu2NuCCIC675zqlaB5g'
        // }
        // window.open(response.url, '_self');
    };

    const verifytoken = async() => {
        console.log('called')
        var config = {
            method: 'GET',
                    url: 'https://dev.powercred.io/location/api/profile',
                    params: {
                        id: 'a2ca9ee0ce434350bbeb2b5a2d7972a0',
                        apikey: 'd3g0ziO2UZoOtIF1QtkfHiXIcS8glAu2NuCCIC675zqlaB5g',
                        place_search_text: 'goa',
                    },
                    headers: {'Content-Type': 'application/json'}
        };
        
        try{
            const response = await axios(config);
            console.log(response.data);
        }
        catch(e){
            console.log('error ', e);
        }
    };

    return ( 
            <div>
                <div>
                    <nav className="">
                        {/* <div className="container"> */}
                            <img src={require('../components/images/images/powercred_logo_2.png')} alt="powercred_logo" height="60" className='pwc-logo' />
                            {/* <div className="navbar-brand" id="google_translate_element_i"></div> */}
                        {/* </div> */}
                        
                    </nav>
                    {/* <div className='menu-icon'>
                        <div className='menu-icon-row'></div>
                        <div className='menu-icon-row'></div>
                        <div className='menu-icon-row'></div>
                    </div> */}
                    <div className="google-translate">
                        <div className={`notranslate google-translate-btn google-translate-en ${!isTranslated ? 'google-translate-btn-selected' : ''}`} onClick={() => translate('en')}> EN </div>
                        <div className={`notranslate google-translate-btn ${isTranslated ? 'google-translate-btn-selected' : ''}`}  onClick={() => translate('id')}> ID </div>
                    </div>    
                </div>
                {/* {
                    partnerPage && <Partner setHome={setHome} isTranslated={isTranslated} translate={translate}/>
                } */}
                {
                    !false && (
                        <div className="main-conatiner">
                            <div className="main-class-nui">
                                <h3 className='to-heading-nui'>{'{Company Name}'} uses Powercred to connect your account</h3>
                                <h4 className='to-heading2-nui'>{'{Company Name}'} does not have access to your account or be able to access your data without your consent</h4>
                                <div>
                                    <div className='xyzq'>
                                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M6 6c0-3.311 2.689-6 6-6s6 2.688 6 6v4h3v14h-18v-14h3v-4zm14 5h-16v12h16v-12zm-13-5v4h10v-4c0-2.76-2.24-5-5-5s-5 2.24-5 5z"/></svg>
                                        {/* <img src={require('../components/images/powercred_logo.jpg')} alt="powercred_logo" height="40" /> */}
                                        <span>Data Security</span>
                                    </div>
                                    <div className='xyzq'>
                                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M12 0c-3.371 2.866-5.484 3-9 3v11.535c0 4.603 3.203 5.804 9 9.465 5.797-3.661 9-4.862 9-9.465v-11.535c-3.516 0-5.629-.134-9-3zm0 1.292c2.942 2.31 5.12 2.655 8 2.701v10.542c0 3.891-2.638 4.943-8 8.284-5.375-3.35-8-4.414-8-8.284v-10.542c2.88-.046 5.058-.391 8-2.701zm5 7.739l-5.992 6.623-3.672-3.931.701-.683 3.008 3.184 5.227-5.878.728.685z"/></svg>
                                        {/* <img src={require('../components/images/powercred_logo.jpg')} alt="powercred_logo" height="40" /> */}
                                        <span>Privacy Protected</span>
                                    </div>
                                    <div className='xyzq'>
                                        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd"><path d="M23.621 9.012c.247.959.379 1.964.379 3 0 6.623-5.377 11.988-12 11.988s-12-5.365-12-11.988c0-6.623 5.377-12 12-12 2.581 0 4.969.822 6.927 2.211l1.718-2.223 1.935 6.012h-6.58l1.703-2.204c-1.62-1.128-3.582-1.796-5.703-1.796-5.52 0-10 4.481-10 10 0 5.52 4.48 10 10 10 5.519 0 10-4.48 10-10 0-1.045-.161-2.053-.458-3h2.079zm-7.621 7.988h-8v-6h1v-2c0-1.656 1.344-3 3-3s3 1.344 3 3v2h1v6zm-5-8v2h2v-2c0-.552-.448-1-1-1s-1 .448-1 1z"/></svg>
                                        {/* <img src={require('../components/images/powercred_logo.jpg')} alt="powercred_logo" height="40" /> */}
                                        <span>Password Protected</span>
                                    </div>
                                </div>
                                <h4 className='to-heading3-nui'>
                                    <span>
                                        Why connect with Powercred? Know more
                                        <svg xmlns="http://www.w3.org/2000/svg" onMouseOver={(e) => {e.currentTarget.nextElementSibling.style.display = 'inline-block'; e.currentTarget.nextElementSibling.style.top = e.clientY-0+'px'; e.currentTarget.nextElementSibling.style.left = e.clientX+10+'px';}} onMouseOut={(e) => e.currentTarget.nextElementSibling.style.display = 'none'} width="13" height="13" fill="black" className='partner-info-icon' viewBox="0 0 16 16">
                                            <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                            <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533L8.93 6.588zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"/>
                                        </svg>
                                        <div className='partner-info-icon-message'>
                                            PowerCred helps you leverage the power of your alternate data by enabling (company name) to gain access and insights from your consented data. This helps you gain access to credit and other financial services in a quick and hassle-free manner, without compromising on your data security and privacy.
                                        </div>
                                    </span>
                                </h4>
                                <button type="button" className='btn nav-btn-pwc continue-btn' onClick={generateToken}>
                                    CONTINUE
                                </button>
                                <h5 className='to-heading4-nui'>By clicking on continue you accept <a href='https://www.powercred.io/terms-of-service' className="a_master_cb" target="_blank">Terms of service</a> and <a href='https://www.powercred.io/privacy-policy' className="a_master_cb" target="_blank">Privacy policies</a>  of Powercred</h5>
                                <h6 className='to-heading5-nui'>
                                    Registered by Kominfo
                                    <img src={require('../components/images/images/kominfo.png')} alt="kominfo_logo" height="35" className='kominfo-logo' />
                                </h6>
                            </div>
                        </div>
                    )
                }
                {isLoading && <FullPageLoader />}
            </div>
     );
}
 
export default ClientHome;